module.exports = __webpack_public_path__ + "img/137.5.337b57c2.png";